import { replaceMailAndLinkWithProperHtmlTemplate } from "../../../core/service/BusinessLogicService"
import { loc } from "../../../core/utils"
import { TunnelDataContext } from "../../../digital-journey/context/TunnelDataContext"
import { resolveStaticDocContent } from "../../../utils/staticDocumentUrls"
import DOMPurify from "dompurify"
import React, { useContext } from "react"

function formatText(template, values) {
  if (typeof template !== "string") return template
  return template.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? "")
}

export default function LegalsSection({ legalsToDisplay, shareCapitalFinancer, shareCapitalGroup, tunnelData }) {
  const { voyageurLangRevision = 0 } = useContext(TunnelDataContext) || {}

  if (!legalsToDisplay || legalsToDisplay.length === 0) return null

  const shareCapitalGroupFormatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(shareCapitalGroup)

  const shareCapitalFormatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(shareCapitalFinancer)
  return (
    <>
      {legalsToDisplay.map((legalText, index, row) => {
        const locProps = {
          shareCapitalFinancer: shareCapitalFormatted,
          shareCapitalGroup: shareCapitalGroupFormatted,
          tunnelData
        }
        const locResolved = loc(legalText, locProps)
        const key = `${legalText}-${index}-${voyageurLangRevision}`

        if (React.isValidElement(locResolved)) {
          return <React.Fragment key={key}>{locResolved}</React.Fragment>
        }

        if (typeof locResolved === "function") {
          const ElementHtml = locResolved
          return (
            <ElementHtml
              key={key}
              shareCapitalFinancer={shareCapitalFormatted}
              shareCapitalGroup={shareCapitalGroupFormatted}
            />
          )
        }

        if (typeof locResolved !== "string") {
          return null
        }

        const label = formatText(locResolved, locProps)
        const resolvedLabel = resolveStaticDocContent(label, tunnelData)
        return (
          <div
            key={key}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                "<p " +
                  (index === row.length - 1 ? 'class="mb-5 mb-sm-0"' : "") +
                  "><small style='text-align: justify; display: inline-block;'>" +
                  replaceMailAndLinkWithProperHtmlTemplate(resolvedLabel) +
                  "</small></p>",
                { ADD_ATTR: ["target", "rel"] }
              )
            }}
          />
        )
      })}
    </>
  )
}
